import { GradientTooltip } from './GradientTooltip';

export default GradientTooltip;
